import { FileText, Star, Clock, TrendingUp } from 'lucide-react';
import KpiCard from './KpiCard';

interface KpiOverviewProps {
    displayedResultsCount: number;
    hiddenCount: number;
    highFitCount: number;
    closingSoonCount: number;
}

export default function KpiOverview({
    displayedResultsCount,
    hiddenCount,
    highFitCount,
    closingSoonCount
}: KpiOverviewProps) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <KpiCard
                label="Actionable Items"
                value={displayedResultsCount}
                subValue={hiddenCount > 0 ? `${hiddenCount} hidden` : undefined}
                icon={<FileText className="w-4 h-4 text-blue-400" />}
                color="blue"
            />
            <KpiCard
                label="High Priority (90%+)"
                value={highFitCount}
                icon={<Star className="w-4 h-4 text-amber-400" />}
                color="amber"
            />
            <KpiCard
                label="Closing < 48h"
                value={closingSoonCount}
                icon={<Clock className="w-4 h-4 text-red-400" />}
                color="red"
            />
            <KpiCard
                label="Pipeline Value"
                value="$2.4M"
                subValue="Est based on matches"
                icon={<TrendingUp className="w-4 h-4 text-emerald-400" />}
                color="emerald"
            />
        </div>
    );
}
